/* Native details keep every destination usable without JavaScript. */
(() => {
  function initialize(root = document) {
    const menus = [...root.querySelectorAll('[data-lcmega]')];
    menus.forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      menu.addEventListener('toggle', () => {
        if (menu.open) document.querySelectorAll('[data-lcmega]').forEach(other => { if (other !== menu) other.open = false; });
      });
      const preview = menu.querySelector('[data-lcmega-preview]');
      const previewLinks = [...menu.querySelectorAll('[data-lcmega-preview-link]')];
      const desktop = window.matchMedia('(min-width: 990px)');
      const pointer = window.matchMedia('(hover: hover) and (pointer: fine)');
      let activeLink, imageVersion = 0, openTimer, closeTimer;
      function showPreview(link) {
        if (!desktop.matches || !preview || !link || link === activeLink) return;
        activeLink?.classList.remove('is-previewed');
        activeLink = link;
        link.classList.add('is-previewed');
        menu.classList.add('has-preview');
        preview.hidden = false;
        preview.querySelector('[data-lcmega-preview-target]').href = link.href;
        preview.querySelector('[data-lcmega-preview-title]').textContent = link.dataset.previewTitle;
        preview.querySelector('[data-lcmega-preview-kind]').textContent = link.dataset.previewKind;
        const image = preview.querySelector('[data-lcmega-preview-image]');
        const media = preview.querySelector('[data-lcmega-preview-media]');
        const fallback = preview.querySelector('[data-lcmega-preview-fallback]');
        const src = link.dataset.previewImage;
        const version = ++imageVersion;
        image.hidden = true;
        image.alt = link.dataset.previewTitle;
        fallback.hidden = Boolean(src);
        media.classList.add('is-loading');
        if (!src) { image.removeAttribute('src'); media.classList.remove('is-loading'); return; }
        const loaded = new Image();
        loaded.onload = () => {
          if (version !== imageVersion) return;
          image.src = src;
          image.hidden = false;
          media.classList.remove('is-loading');
        };
        loaded.onerror = () => {
          if (version !== imageVersion) return;
          fallback.hidden = false;
          media.classList.remove('is-loading');
        };
        loaded.src = src;
      }
      function showInitial() {
        if (!activeLink) showPreview(previewLinks.find(link => link.dataset.previewImage && link.getClientRects().length) || previewLinks[0]);
      }
      menu.addEventListener('pointerover', event => {
        if (event.pointerType === 'touch') return;
        const link = event.target.closest('[data-lcmega-preview-link]');
        if (link && !link.contains(event.relatedTarget)) showPreview(link);
      });
      menu.addEventListener('focusin', event => {
        const link = event.target.closest('[data-lcmega-preview-link]');
        if (link) showPreview(link);
      });
      menu.addEventListener('toggle', () => { if (menu.open) showInitial(); });
      menu.addEventListener('pointerenter', () => {
        if (!desktop.matches || !pointer.matches) return;
        clearTimeout(closeTimer);
        openTimer = setTimeout(() => { menu.open = true; }, 120);
      });
      menu.addEventListener('pointerleave', () => {
        clearTimeout(openTimer);
        if (!desktop.matches || !pointer.matches) return;
        closeTimer = setTimeout(() => { if (!menu.querySelector(':focus-visible')) menu.open = false; }, 260);
      });
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') { clearTimeout(openTimer); clearTimeout(closeTimer); }
      });
      desktop.addEventListener('change', () => {
        activeLink = null;
        if (desktop.matches && menu.open) showInitial();
      });
      const filter = menu.querySelector('[data-lcmega-filter]');
      const groups = [...menu.querySelectorAll('[data-lcmega-group]')];
      filter.addEventListener('input', () => {
        const query = filter.value.toLocaleLowerCase().trim();
        let count = 0;
        groups.forEach(group => {
          const categoryMatch = group.querySelector('h3').textContent.toLocaleLowerCase().includes(query);
          let matches = 0;
          group.querySelectorAll('[data-lcmega-product]').forEach(row => {
            row.hidden = Boolean(query) && !categoryMatch && !row.textContent.toLocaleLowerCase().includes(query);
            if (!row.hidden) matches++;
          });
          group.hidden = Boolean(query) && !categoryMatch && matches === 0;
          if (!group.hidden) count++;
          const list = group.querySelector('details');
          if (list) {
            if (query && !list.dataset.filtering) { list.dataset.wasOpen = String(list.open); list.dataset.filtering = 'true'; }
            if (query) list.open = !group.hidden;
            else if (list.dataset.filtering) { list.open = list.dataset.wasOpen === 'true'; delete list.dataset.filtering; }
          }
        });
        menu.querySelector('[data-lcmega-empty]').hidden = count > 0;
        const visibleLinks = previewLinks.filter(link => link.getClientRects().length && !link.closest('[hidden]'));
        const match = (query && visibleLinks.find(link => link.closest('[data-lcmega-product]'))) || visibleLinks[0];
        if (match) showPreview(match);
        else if (preview) { preview.hidden = true; activeLink?.classList.remove('is-previewed'); activeLink = null; }

      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-lcmega]')) document.querySelectorAll('[data-lcmega][open]').forEach(menu => { menu.open = false; });
  });
  document.addEventListener('keydown', event => {
    const openMenu = document.querySelector('[data-lcmega][open]');
    if (event.key === 'Escape' && openMenu) { openMenu.open = false; openMenu.querySelector('summary').focus(); }
    const shell = document.querySelector('[data-nav-shell].is-open');
    if (event.key === 'Tab' && shell && window.innerWidth < 990) {
      const targets = [...shell.querySelectorAll('a,button,input,summary')].filter(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
      const first = targets[0], last = targets[targets.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }
  });
  document.querySelector('[data-menu-toggle]')?.addEventListener('click', () => {
    requestAnimationFrame(() => document.querySelector('[data-menu-close]')?.focus());
  });
  document.querySelector('[data-menu-close]')?.addEventListener('click', () => document.querySelector('[data-menu-toggle]')?.focus());
})();

